import React, { useEffect, useState } from "react";
import { VStack, HStack, Text, Button, Spinner, Box } from "@chakra-ui/react";
import { StepProps } from "../../../../../../../utils/types/step";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../../../redux/reducer/rootReducer";
import * as Yup from "yup";
import StepHeader from "../../../../../../../components/StepperHeader";
import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import { color } from "../../../../../../../utils/theme";
import DriverDiagram, { DriverDiagramProps } from "../../../../../../../components/diagrams/driver";
import { ChangeIdea } from "./changeIdea";
import { FishboneData } from "../../forms";
import { map } from "lodash";

const Driver = (props: StepProps) => {
  const [loading, setLoading] = useState(false);
  const [driverDiagramData, setDriverDiagramData] = useState<DriverDiagramProps>({
    key: 0,
    goal: "Goal",
    primaryDrivers: [],
  });
  const fishboneDiagramData = useSelector(
    (state: RootState) => state.form.formData["4"]
  ) as FishboneData;

  const changeIdeaData = useSelector(
    (state: RootState) => state.form.formData["7"]
  );

  const mapData = () => {

     let data:any[] = [];

  // [  for (let i = 0; i < Object.keys(fishboneDiagramData).length; i++) {
  //     da]ta.concat(fishboneDiagramData);
  //   }

    Object.values(fishboneDiagramData.causes).forEach((element, index) => {
      console.log("element: ", element);
      
      data.push(...element.primaryCauses);
    });
    console.log("hihiihiiSS", data)
    console.log("changeIdeaData: ", changeIdeaData);
    

   let driverData2 = data.map((item) => {
    console.log(item)
     return {
       name: item.primary,
       secondaryDrivers: item.secondaryCauses.map((secondaryCause: any) => {
         return {
           name: secondaryCause, // Use the current `secondaryCause` correctly
           changeIdea: Object.values(changeIdeaData)
             .filter((changeIdea: ChangeIdea) => {
               return changeIdea.problem === secondaryCause; // Compare with the specific secondary cause
         }).flatMap((changeIdeaParent: any) => {
          console.log("skiiiii",changeIdeaParent);
          
           return changeIdeaParent.changeIdea?.map((changeIdea: ChangeIdea) => {
             return {
               name: "sajdhaskjdhaskjdha", // Map the `changeIdea` field to `name`
             };
           });
         }),

         };
       }),
     };
   });

    console.log("fishboneDiagramData: ", fishboneDiagramData);

    console.log("data for kaleb: ", driverData2);
    return driverData2;
    


    

  };
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      console.log("changeIdea map: ", changeIdeaData);
      mapData();
      let secondaryCauseWithChangeIdeas = Object.values(changeIdeaData).flatMap(
        (changeIdea: ChangeIdea) => {
          return changeIdea?.changeIdea.map((change: string) => {
            return {
              secondaryCause: changeIdea.problem,
              changeIdea: change,
            };
          });
        }
      );

      let mainCatagoryWithChangeIdeas = secondaryCauseWithChangeIdeas.map(
        (secondaryCause: { secondaryCause: string; changeIdea: string }) => {
          console.log(
            "mapped driver diagram data: ",
            fishboneDiagramData.causes.filter((cause) => {
              return cause.primaryCauses.some((primaryCause) => {
                return primaryCause.secondaryCauses.includes(
                  secondaryCause.secondaryCause
                ); // Replace `secondaryCauseValue` with the value you're checking
              });
            })
          );

          return {
            primaryCause: fishboneDiagramData.causes.filter((cause) => {
              return cause.primaryCauses.some((primaryCause) => {
                return primaryCause.secondaryCauses.includes(
                  secondaryCause.secondaryCause
                );
              });
            })[0].category,
            secondaryCause: secondaryCause.secondaryCause,
            changeIdea: secondaryCause.changeIdea,
          };
        }
      );


      console.log("mainCatagoryWithChangeIdeas: ", mainCatagoryWithChangeIdeas);

      let diagramData: DriverDiagramProps = {
        key: 0,
        goal: "Goal",
        primaryDrivers: mainCatagoryWithChangeIdeas.map((item) => ({
          name: item.primaryCause,
          secondaryDrivers: [
            {
              name: item.secondaryCause,
              changeIdea: [
                {
                  name: item.changeIdea,
                },
              ],
            },
          ],
        })),
      };


      console.log("Driver diagram data: ", diagramData);

      setDriverDiagramData(diagramData);
      


      
      




      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <StepHeader
        title="Driver Diagram"
        description="Congratulations you have "
      />
      {loading ? (
        <Spinner color={color.primary} size={"md"} mt={15} />
      ) : (
        <>
        <VStack h={"70%"} w={"100%"}  display={"flex"} flexDirection={"column"}>
          <Box  w={"100%"} flex={0.9} sx={{ overflowY: "scroll" }}>
            <DriverDiagram
              key={driverDiagramData?.key}
              goal={driverDiagramData?.goal}
              primaryDrivers={mapData()}
            />
          </Box>
       
        </VStack>
           <HStack
            flex={0.1}
            w="100%"
            justifyContent="space-between"
            p={4}
            bg="gray.50"
          >
            <Button
              colorScheme="blue"
              variant="outline"
              leftIcon={<ArrowLeftIcon />}
              onClick={() => {
                props.onPrev && props.onPrev();
              }}
            >
              Previous
            </Button>
            <HStack>
              <Button
                isLoading={props.loading}
                colorScheme="blue"
                variant="outline"
                onClick={() => {
                  // setSaveAndExist(true);
                  // formik.handleSubmit();
                  // console.log("Saved values:", formik.values);
                }}
              >
                Save & Exit
              </Button>
              <Button
                colorScheme="blue"
                onClick={() => {
                  // setSaveAndExist(false);
                  // if (formik.isValid && formik.values.problemStatement === "") {
                  //   setShowSummarizedProblemStatement(true);
                  // } else if (
                  //   showSummarizedProblemStatement &&
                  //   formik.values.problemStatement !== ""
                  // ) {
                  //   formik.handleSubmit();
                  // } else {
                  //   setShowSummarizedProblemStatement(true);
                  // }

                  console.log("next clicked");

                  // formik.handleSubmit();
                  props.onNext();
                }}
                w={"50%"}
                rightIcon={<ArrowRightIcon />}
              >
                Next
              </Button>
            </HStack>
          </HStack>
          </>
      )}
    </>
  );
};

export default Driver;
